/**
 * @desc Controller for the csPresenceIndicator directive
 */
;(function () {
  angular
    .module('contrast.presence')
    .controller('csPresenceIndicatorCtrl', [
      '$filter',
      'presenceStatuses',
      csPresenceIndicatorCtrl
    ])

  function csPresenceIndicatorCtrl($filter, presenceStatuses) {
    var vm = this

    // Public methods
    vm.activate = activate
    vm.isOnline = isOnline
    vm.isCase = isCase
    vm.determineTooltipPlacement = determineTooltipPlacement
    vm.determineUibTooltip = determineUibTooltip
    vm.determineUibTooltipTemplate = determineUibTooltipTemplate

    // Non-public vars
    var tooltipCase
    var format
    var tooltipTpl =
      'views/csPresenceIndicator/cs-presence-indicator.tooltip.html'

    function activate(scope) {
      if (!scope) {
        throw new Error('scope is required')
      }
      tooltipCase = scope.tooltipCase
      vm.status = scope.status.toLowerCase()
      format = scope.format
      if (!angular.isUndefined(scope.lastActivity)) {
        vm.lastActivity = scope.lastActivity
      }
    }

    function isOnline() {
      return vm.status == presenceStatuses.online
    }

    function isCase(name) {
      return tooltipCase == name
    }

    function determineTooltipPlacement() {
      return isCase('verbose') ? 'right' : 'bottom'
    }

    function determineUibTooltip() {
      if (isCase('status')) {
        return $filter('capitalize')(vm.status)
      } else if (isCase('lastActivity')) {
        return $filter('date')(vm.lastActivity, format)
      }
      return undefined // will not even set the attribute
    }

    function determineUibTooltipTemplate() {
      if (isCase('verbose')) {
        return tooltipTpl
      }
      return undefined
    }
  }
}).call(this)
